import { Box, Button } from "@mui/material";
import {
  CONNECTION_TYPE,
  IP_METHOD,
  CONNECTION_TYPE_OPTIONS,
  IP_METHOD_OPTIONS,
} from "../constants/network";
import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { FormField } from "../";

const styles = () => {
  return {
    "& .select-network": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .mui-field": {
      "& .MuiInputBase-root": {
        borderBottom: 0,
      },
      "& .MuiFormGroup-root": {
        justifyContent: "center",
        "& .MuiFormControlLabel-root": {
          width: "120px",
        },
      },
    },
    "& .button-footer": {
      mt: 1,
      pt: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      borderTop: "1px solid rgba(0, 64, 87, 0.25)",
    },
  };
};

const ConfigureNetwork = ({
  networkSettings,
  loading,
  onClickSave,
  onCancel,
  onClickSelectNetwork,
  ipMethodSelect = false,
}) => {
  const [formData, setFormData] = useState({
    connectionType: CONNECTION_TYPE.ethernet,
    method: IP_METHOD.dhcp,
    ip: "",
    netmask: "",
    gateway: "",
    primaryDNS: "",
    secondaryDNS: "",
  });

  useEffect(() => {
    const ethernet = networkSettings?.settings?.ethernet;
    const wifi = networkSettings?.settings?.wifi;
    if (ethernet && ethernet?.primary) {
      let primaryDNS = "";
      let secondaryDNS = "";
      if (ethernet?.dns?.length > 0) {
        primaryDNS = ethernet?.dns[0];
        secondaryDNS = ethernet?.dns[1];
      }

      setFormData({
        ...formData,
        connectionType: CONNECTION_TYPE.ethernet,
        method: ethernet?.method,
        ip: ethernet?.ip || "",
        netmask: ethernet?.netmask || "",
        gateway: ethernet?.gateway || "",
        primaryDNS: primaryDNS,
        secondaryDNS: secondaryDNS,
      });
    } else if (wifi && wifi?.primary) {
      setFormData({
        ...formData,
        connectionType: CONNECTION_TYPE.wifi,
        method: wifi.method,
      });
    }
  }, [networkSettings]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isDisabled = () => {
    if (
      formData.connectionType === CONNECTION_TYPE.ethernet &&
      formData.method === IP_METHOD.static
    ) {
      return !Object.values(formData).every((it) => it);
    }
    return false;
  };

  const onSave = () => {
    let data = {
      ethernet: {
        method: formData.method,
      },
    };

    if (formData.method === IP_METHOD.static) {
      data = {
        ethernet: {
          method: formData.method,
          ip: formData.ip,
          netmask: formData.netmask,
          gateway: formData.gateway,
          dns: [formData.primaryDNS, formData.secondaryDNS],
        },
      };
    }

    onClickSave(data);
  };

  return (
    <Box sx={styles}>
      <Box>
        <FormField
          showLabel={true}
          formFieldLabel="Connection Type"
          name="connectionType"
          type="radioboxgroup"
          value={formData.connectionType}
          variant="filled"
          onChange={onChange}
          options={CONNECTION_TYPE_OPTIONS}
        />

        {formData.connectionType === CONNECTION_TYPE.wifi && (
          <Box mt={4} className="select-network">
            <Button
              onClick={onClickSelectNetwork}
              sx={{ width: "260px", ml: -4 }}
              variant="contained"
            >
              Select Network
            </Button>
          </Box>
        )}

        {formData.connectionType === CONNECTION_TYPE.ethernet && (
          <FormField
            showLabel={true}
            formFieldLabel="IP Method"
            name="method"
            type={ipMethodSelect ? "select" : "radioboxgroup"}
            value={formData.method}
            variant="filled"
            onChange={onChange}
            options={IP_METHOD_OPTIONS}
          />
        )}

        {formData.connectionType === CONNECTION_TYPE.ethernet &&
          formData.method === IP_METHOD.static && (
            <Box>
              <FormField
                showLabel={true}
                formFieldLabel="IP Address"
                name="ip"
                value={formData.ip}
                variant="filled"
                onChange={onChange}
                autoComplete="off"
                type="ipInput"
              />

              <FormField
                showLabel={true}
                formFieldLabel="Netmask"
                name="netmask"
                value={formData.netmask}
                variant="filled"
                onChange={onChange}
                autoComplete="off"
                type="ipInput"
              />

              <FormField
                showLabel={true}
                formFieldLabel="Gateway"
                name="gateway"
                value={formData.gateway}
                variant="filled"
                onChange={onChange}
                autoComplete="off"
                type="ipInput"
              />

              <FormField
                showLabel={true}
                formFieldLabel="Primary DNS"
                name="primaryDNS"
                value={formData.primaryDNS}
                variant="filled"
                onChange={onChange}
                autoComplete="off"
                type="ipInput"
              />

              <FormField
                showLabel={true}
                formFieldLabel="Secondary DNS"
                name="secondaryDNS"
                value={formData.secondaryDNS}
                variant="filled"
                onChange={onChange}
                autoComplete="off"
                type="ipInput"
              />
            </Box>
          )}

        <Box className="button-footer">
          <Button onClick={onCancel}>Cancel</Button>
          {formData.connectionType === CONNECTION_TYPE.ethernet && (
            <LoadingButton
              onClick={onSave}
              disabled={isDisabled()}
              loading={loading}
            >
              Save
            </LoadingButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ConfigureNetwork;
